import React, { Fragment, useEffect } from "react";
import { Field } from "react-final-form";

import { InputField, ReactDropzone } from "modules/4_final_form/mobile";
import { FieldArray } from "react-final-form-arrays";

import { Block, BlockTitle, List } from "framework7-react";
import ActionItemsFieldArray from "modules/project/qa/action_items/mobile/FieldArray";

const ProjectAreaTab = (props) => {
  const {
    project_area,
    form: { change },
    values: { area_links_attributes },
    users,
    project_qa_action_items_statuses,
    current_user,
    project_id,
    handleSubmit,
    index,
  } = props;

  let arrayKey = _.findKey(area_links_attributes, (al) => al.value == project_area?.id);
  const findKey = arrayKey ? arrayKey : index;
  const fieldArrayName = `area_links_attributes[${findKey}]`;

  useEffect(() => {
    if (project_area) {
      change(`${fieldArrayName}.project_area_id`, project_area.id);
    }
  }, []);

  let addProps = {
    project_id: project_id,
    project_area_links_attributes: [{ project_area_id: project_area?.id }],
    author_id: current_user.id,
  };

  return (
    <Block>
      <List>
        <BlockTitle slot="list">{project_area?.name}</BlockTitle>
        <Field label="Comments" component={InputField} type="textarea" name={`${fieldArrayName}.comments`} slot="list" />
        <BlockTitle slot="list">Area Surveillance Attachments</BlockTitle>
        <FieldArray component={ReactDropzone} name={`${fieldArrayName}.attachments_attributes`} slot="list" uploadNow />
        <Block slot="list">
          <ActionItemsFieldArray
            name={`${fieldArrayName}.action_items_attributes`}
            users={users}
            project_qa_action_items_statuses={project_qa_action_items_statuses}
            handleSubmit={handleSubmit}
            addProps={addProps}
          />
        </Block>
      </List>
    </Block>
  );
};

export default ProjectAreaTab;
